import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

const personalFeatures = ['基本コールセンター対応','月間500件まで対応','メール・電話サポート','月次レポート提供','専任担当者アサイン','業務フロー設計支援'];
const businessFeatures = ['フルコールセンター運営','月間件数無制限','24時間対応オプション','週次・月次レポート','複数担当者アサイン','SLA保証','カスタマイズ対応','優先サポート'];

export default function PricingPage() {
  return (
    <>
      <Navbar />
      <main className="bg-white min-h-screen">
        <section className="relative bg-[#0f1628] geo-pattern pt-32 pb-20">
          <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
            <span className="font-cormorant text-[#c9a84c] text-sm tracking-[0.4em] uppercase block mb-3">Pricing</span>
            <h1 className="font-serif-jp text-white text-4xl md:text-5xl tracking-wider font-medium mb-4">料金プラン</h1>
            <div className="flex items-center gap-3"><div className="w-12 h-px bg-[#c9a84c]"></div><div className="w-1.5 h-1.5 bg-[#c9a84c] rotate-45"></div></div>
          </div>
        </section>

        <section className="py-20 md:py-28 bg-[#f8f5ef]">
          <div className="max-w-5xl mx-auto px-6 md:px-10">
            <div className="text-center mb-14">
              <p className="text-[#0f1628]/50 text-sm font-sans">※ 表示価格はすべて税別・月額の目安です。詳細はお問い合わせください。</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Personal */}
              <div className="bg-white border border-[#0f1628]/10 p-10">
                <div className="inline-block border border-[#c9a84c] text-[#c9a84c] text-xs px-4 py-1 tracking-widest font-sans mb-6">PERSONAL</div>
                <h2 className="font-serif-jp text-[#0f1628] text-xl tracking-wider mb-2">個人事業主向けプラン</h2>
                <p className="text-[#0f1628]/40 text-xs font-sans mb-6">フリーランス・個人事業主の方に最適</p>
                <div className="flex items-end gap-2 mb-2">
                  <span className="font-cormorant text-[#0f1628] text-5xl font-light">¥50,000</span>
                  <span className="text-[#0f1628]/40 text-sm font-sans mb-2">〜 / 月額</span>
                </div>
                <div className="w-full h-px bg-[#0f1628]/10 my-6"></div>
                <ul className="flex flex-col gap-3 mb-8">
                  {personalFeatures.map((f) => (
                    <li key={f} className="flex items-center gap-3 text-[#0f1628]/60 text-xs font-sans">
                      <i className="ri-check-line text-[#c9a84c]"></i>{f}
                    </li>
                  ))}
                </ul>
                <Link to="/contact" className="block text-center border border-[#0f1628] text-[#0f1628] py-3 text-xs tracking-widest font-sans hover:bg-[#0f1628] hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer">お問い合わせ</Link>
              </div>

              {/* Business */}
              <div className="bg-[#0f1628] border border-[#c9a84c] p-10 relative">
                <div className="absolute top-0 right-0 bg-[#c9a84c] text-[#0f1628] text-xs px-4 py-1 tracking-widest font-sans font-medium">POPULAR</div>
                <div className="inline-block border border-[#c9a84c] text-[#c9a84c] text-xs px-4 py-1 tracking-widest font-sans mb-6">BUSINESS</div>
                <h2 className="font-serif-jp text-white text-xl tracking-wider mb-2">中小企業向けプラン</h2>
                <p className="text-white/40 text-xs font-sans mb-6">成長中の中小企業・スタートアップに最適</p>
                <div className="flex items-end gap-2 mb-2">
                  <span className="font-cormorant text-[#c9a84c] text-5xl font-light">¥200,000</span>
                  <span className="text-white/40 text-sm font-sans mb-2">〜 / 月額</span>
                </div>
                <div className="w-full h-px bg-[#c9a84c]/20 my-6"></div>
                <ul className="flex flex-col gap-3 mb-8">
                  {businessFeatures.map((f) => (
                    <li key={f} className="flex items-center gap-3 text-white/60 text-xs font-sans">
                      <i className="ri-check-line text-[#c9a84c]"></i>{f}
                    </li>
                  ))}
                </ul>
                <Link to="/contact" className="block text-center bg-[#c9a84c] text-[#0f1628] py-3 text-xs tracking-widest font-sans font-medium hover:bg-[#e8c97a] transition-all duration-300 whitespace-nowrap cursor-pointer">お問い合わせ</Link>
              </div>
            </div>

            <div className="mt-12 border border-[#0f1628]/10 p-8 bg-white">
              <h3 className="font-serif-jp text-[#0f1628] text-lg tracking-wider mb-4">カスタムプランについて</h3>
              <p className="text-[#0f1628]/50 text-sm font-sans leading-relaxed mb-6">上記プラン以外にも、貴社のニーズに合わせたカスタムプランをご用意しております。業務内容・規模・ご予算に応じて柔軟にご対応いたします。まずはお気軽にご相談ください。</p>
              <Link to="/contact" className="inline-flex items-center gap-2 text-[#c9a84c] text-xs tracking-widest font-sans hover:underline cursor-pointer whitespace-nowrap">
                カスタムプランを相談する <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
